export const API_BASE_URL = "https://api.avexa.net";
// export const API_BASE_URL = "https://apionecare.avexa.net";
// export const API_BASE_URL = "http://localhost:8232";

export const REDIRECT_AVEXA_BASE_URL = "https://onecare.avexa.net/en/";
// export const REDIRECT_AVEXA_BASE_URL = "http://localhost:3000/en/";
// export const API_BASE_URL = "https://whp.api.avexa.net";

export const TEMP_SECRET_KEY = "onecare-avexa-secret-key-32bytes";
export const REACT_APP_API_BASE_URL="https://onecare.avexa.net"
// export const REACT_APP_API_BASE_URL="http://localhost:3000"

export const REACT_API_URL="https://api.avexa.net/"
// export const WEBSITE_URL= window.location.origin;
export const WEBSITE_URL= `https://muktawomensclinic.avexa.net/`;
